import { ReactElement } from 'react'

import { ExpandedRowsContextProvider } from '@features/reports/contexts/expandedRowsContext'
import { TrialBalanceReport } from '@features/reports/views/NL/trialBalanceReport'
import { useTrialBalanceData } from '@features/reports/views/NL/trialBalanceReport/hooks/useTrialBalanceData'

export const TrialBalance = (): ReactElement => {
  const { allExpandableIds } = useTrialBalanceData()

  return (
    <ExpandedRowsContextProvider allExpandableIds={allExpandableIds}>
      <TrialBalanceReport />
    </ExpandedRowsContextProvider>
  )
}
